// Helpers para destacar el/los producto(s) usados en la última generación
// exitosa. Se persisten como array de ids en localStorage bajo
// 'atlas-v2-last-products' (lo escribe InterfazV2 al confirmar). Los menús
// de "Elegir de mis productos" los flotan arriba con un badge "Último
// utilizado".

const LAST_USED_KEY = 'atlas-v2-last-products';

export function getLastUsedProductIds(): string[] {
  try {
    const raw = localStorage.getItem(LAST_USED_KEY);
    if (!raw) return [];
    const ids = JSON.parse(raw);
    return Array.isArray(ids) ? ids.map((id) => String(id)) : [];
  } catch {
    return [];
  }
}

// Ordena una lista de productos poniendo primero los usados por última vez
// (en el orden en que se guardaron) y dejando el resto como estaba. El sort
// es estable, así que los no-últimos conservan su posición relativa.
export function sortLastUsedFirst<T extends { id: string }>(
  items: T[],
  lastUsedIds: string[],
): T[] {
  if (lastUsedIds.length === 0) return items;
  const rank = new Map(lastUsedIds.map((id, i) => [id, i]));
  return [...items].sort((a, b) => {
    const ra = rank.has(a.id) ? (rank.get(a.id) as number) : Infinity;
    const rb = rank.has(b.id) ? (rank.get(b.id) as number) : Infinity;
    return ra - rb;
  });
}
